import classNames from "classnames";
import RenderLoading from "./partials/renderLoading";

type Props = {};

const Activities = (props: Props) => {
  let loading = true;
  let error = false;
  let data = true;

  if (loading) {
    return <RenderLoading />;
  }

  if (data) {
    return (
      <>
        <div className={classNames("activities-container")}>Activities</div>
      </>
    );
  }
};

export default Activities;
